module.exports = function(fn) {
  return function(a, b, c, d) {
    return fn.apply(null, arguments);
  };
};



//////////////////
// WEBPACK FOOTER
// ./~/arity-n/4.js
// module id = ./node_modules/arity-n/4.js
// module chunks = portal incabStudent incabManager incabTeacher incabHelpdesk marathons